// Kundenrouten, auf denen bereichsweite Hinweise (z. B. Impfpass-Erneuerung) stehen:
// /dashboard, /kundenausweis, /daycare/zweithund (jeweils samt Unterpfaden) und alles unter /dog/.
// Eigene Mini-Datei als Regex, weil sie im Einstiegs-Chunk landet (KundenbereichHinweiseTor in
// App.tsx) und die Startkette von /dashboard am Bundle-Budget steht.
export const istKundenPfad = (pfad: string) => /^\/(dashboard|kundenausweis|daycare\/zweithund)(\/|$)|^\/dog\//.test(pfad);
